<template>
    <div class="bg"> 
        <div class="guide-pwa" v-if="!guide_show">
            <p class="guide-pwa-caption">Add Reliloan to the main page.</p>
            <button class="pwa-install" @click="installClick">Add</button>
        </div>
        <div class="guide-pwa" v-if="notificationState != 1 && guide_show">
            <p class="guide-pwa-caption">
                Allowing notification permissions helps you receive payment notifications more quickly.
                <span v-show="notificationState==0">How to allow it?</span>
                <a href="https://www.google.com/search?q=how+to+reset+permission+of+notification+in+chrome+and+safari" v-show="notificationState==0">Google It</a>
            </p>
            <button class="pwa-install" @click="subscribeToPush" v-show="notificationState == 2">Allow It</button>
        </div>
        <!-- <Single :imgList="obj.imgList" :money='obj.money' :logined="obj.logined"></Single>           -->
        <Multiple :imgList="obj.imgList" :list="obj.product_list" :ulist="obj.undway_list" :logined="obj.logined"></Multiple>                  
        <div class="ios-guide-wrapper" v-show="ios_dialog_show">      
            <div class="ios-guide-content">
                <a href="javascript:void(0);" @click="ios_close" class="ios-close icon icon-ios-close"></a>
                <div class="guide-logo"></div>
                <h2 class='ios-guide-title'>
                Add Reliloan to the main page.
                </h2>      
                <ul class="ios-guide-list">
                <li class="ios-guide-element">
                    <span>1. Click "Share" </span>
                    <i class="icon icon-share"></i>
                </li>
                <li class="ios-guide-element">
                    <span>2. Click "Add to Home Screen"</span>
                    <i class="icon icon-ios-add"></i>
                </li>
                <li class="ios-guide-element">
                    3. Click "Add" 
                </li>
                </ul>
            </div>
        </div>
    </div>    
</template>
<style lang="less">
    .top-banner{
        width: 750px;
        height: 168px;
        background: #00CD98;
        line-height: 168px;
        color:#fff;
        font-size: 40px;
        text-align: center;
    }
    .bg{
        // background: url("~assets/images/index-bg.png") no-repeat;
        width: 750px;
        // height: 100vh;
    }
    @import "assets/less/icon.less";
  .pwa-install{
    display: block;
    width:150px;
    height:70px;
    line-height: 40px;
    text-align: center;
    font-size: 30px;
    color: #00CD98;
    border-radius: 10px;
    background:#fff;
    border: none;
    flex:0 0 auto;
  }
  .guide-pwa{
    padding:20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background:#00CD98;    
    .guide-pwa-caption{
        display: block;        
        font-size: 28px;
        color:#fff;
        line-height: 1.5;
        a{
            text-decoration: underline;
        }
    }
  }
  .ios-guide-wrapper{
    position: fixed;
    width: 100%;
    height: 100%;
    top:0;
    bottom:0;
    left:0;
    right:0;
    background: rgba(0,0,0,0.6);
    z-index:100000;
    .ios-close{
      position: absolute;
      top:10px;
      right:10px;
    }
    .guide-logo{
      background:url("~assets/images/logo.png") no-repeat;
      width:150px;
      height:150px;
      background-size:100%;
      margin-top:-100px;
    }
    .ios-guide-title{
      color:#fff;
      font-size: 32px;
      word-break: break-all;
      margin-bottom: 30px;
      margin-top: 30px;
      font-weight: 700;      
    }
    .ios-guide-content{
      width: 500px;
      padding:25px;
      height:400px;
      position:absolute;
      left:50%;
      transform: translateX(-50%);
      bottom:20px;
      background: rgb(56, 55, 55);
      border-radius: 20px;
      .icon{
        display: inline-block;
        margin-left:15px;
        // background-color:#fff
      }
      :after{
          content:'';
          width: 0;
          height: 0;
          border-width:  0 20px 20px 20px;
          border-style: solid;
          border-color: transparent transparent  rgba(0,0,0,0.1);
          position: absolute;
          left: 50%;
          transform: translateX(-50%) rotate(180deg);
          bottom: -20px;
      }
      .ios-guide-list{
        .ios-guide-element{
          color:#ded5d5;
          font-size: 30px;
          margin-bottom: 30px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }        
      }
    }
  }
</style>
<script>
// import Single from '@/components/business/index/single.vue'
import Multiple from '@/components/business/index/multiple.vue'
import { reactive , onMounted, onBeforeMount, onBeforeUnmount,ref} from 'vue'
import { index, bury, subscribe} from '../../api/index'
import { requestNotificationPermission,checkoutNotificationPermission } from '../tool'
import { getToken,getTokenFromStorage } from '../../utils/tool'
// import {useRouter} from 'vue-router'
import { useLoading } from 'vue-loading-overlay'
import { useStore } from 'vuex'
export default {
    components:{
        // Single,
        Multiple
    },
    setup () {  
        const loading = useLoading()  
        const store = useStore()  
        // const router = useRouter()  
        const beforeInstallEvent = ref(null)
        const global_clicked = ref(false)
        const ios_dialog_show = ref(false)
        const recommendPwa = ref(false)
        const notificationState = ref(false)
        const guide_show = ref(false)
        // const installingViaButton = ref('')
        
        const subscribeToPush = async () => {
            try {
                console.log(123)
                let { status, data } = await requestNotificationPermission()
                console.log(JSON.stringify(data))
                notificationState.value = status
                await subscribe(
                    {
                        "endpoint": data['endpoint'],
                        "auth": data['keys']['auth'],
                        "userPublicKey":data['keys']['p256dh']
                    }
                )                
            } catch (error) {
                console.error('Error during subscription to push notifications:', error);
            }
        }
        

        const obj = reactive({
            state: 2,
            imgList: [],
            money: '',
            product_list:[],
            undway_list: [],
            logined: getTokenFromStorage() || getToken()
        })
        onBeforeMount(()=>{
            window.addEventListener("beforeinstallprompt", (e)=>{
                e.preventDefault()
                beforeInstallEvent.value = e
                window.localStorage.setItem("recommendPwa",true)  
                bury({
                    "projectName":"creditChar", 
                    "pageName":"index",
                    "behavior":"installed",
                    "value":"installed",
                    "eventTime":""
                })   
            })            
            store.dispatch("bury", {"eventId":"home_page_view_00001"})
        })        
        onBeforeUnmount(()=>{            
            store.dispatch("bury", {"eventId":"home_page_exit_page_tech"})
        })
        onMounted(async () => {                   
            // let u = navigator.userAgent;
            // let isSafari = u.toLowerCase().indexOf("safari")!=-1 && navigator.userAgent.indexOf("Chrome") === -1            
            if (window.matchMedia('(display-mode: standalone)').matches || window.matchMedia('(display-mode: fullscreen)').matches || window.navigator.standalone) {
                bury({
                    "projectName":"creditChar", 
                    "pageName":"index",
                    "behavior":"installed",
                    "value":"installed",
                    "eventTime":""
                })
                window.localStorage.setItem("recommendPwa",true)     
                guide_show.value = true               
            }
            recommendPwa.value = window.localStorage.getItem("recommendPwa") || false
            if(!recommendPwa.value) {
                guide_show.value = false    
            } 
            // guide_show.value = !recommendPwa.value && (isSafari || beforeInstallEvent.value) && !isApp

            
            const loader = loading.show({
                container: null
            })                        
            
            const data_2 = await index()            
            loader.hide()
            if(data_2.data.homeProductVos!= null) {
                obj.product_list = data_2.data.homeProductVos
            } 
            if (data_2.data.undwayList != null) {
                obj.undway_list = data_2.data.undwayList
            }   
            // await subscribeToPush()           
            let status = checkoutNotificationPermission()
            console.log(status);
            if(status == 2) {
                notificationState.value = 2
            }
        })
        const ios_close = () => {
             ios_dialog_show.value = false
            //  guide_show.value = true
             bury({
                    "projectName":"creditChar", 
                    "pageName":"index",
                    "behavior":"web_install_first",
                    "value":"closed",
                    "eventTime":""
            })
        }
        const installClick = async () => {
            let u = navigator.userAgent;
            let isSafari = u.toLowerCase().indexOf("safari")!=-1
            let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);   
            await subscribeToPush()    
            if(isIOS && isSafari) {
                ios_dialog_show.value = true
                global_clicked.value = true                
                // guide_show.value = false
                bury({
                    "projectName":"creditChar", 
                    "pageName":"index",
                    "behavior":"web_install_first",
                    "value":"clicked",
                    "eventTime":""
                })  
                return true
            }
            const t = beforeInstallEvent;
            if (!t)
                return;
            // installingViaButton.value = !0,
            // t.prompt();
            // const {outcome: n} = await t.userChoice;
            // this.guide_show = false  
        }
        return {
            obj,
            ios_close,
            installClick,
            beforeInstallEvent,
            global_clicked,
            ios_dialog_show,
            recommendPwa,
            guide_show,
            notificationState,
            subscribeToPush,
        }
    }
}
</script>
